<template>
  <div class="largescreen-page" style="min-height: 1080px;">
    <div class="largescreen-top">
      <div class="top-left">
        <img src="@/assets/images/larg/topicon.png"/>
        <p>飞机运行安全风险管理系统</p>
        <span @click="goSystem">进入系统</span>
      </div>
      <div class="top-right"></div>
    </div>
    <div class="largescreen-box">
      <div class="largescreen-left">
        <div class="largescreen-li">
          <div class="largescreen-head">日颠簸统计</div>
          <echarts2 ref="chart2" class="height-box" :listBumpMorn="listBumpMorn"/>
        </div>
        <div class="largescreen-li" style="margin-top: 24px">
          <div class="largescreen-head">早出港航班(08:00 - 10:00)</div>
          <echarts3 ref="chart3" class="height-box" :listBumpMorn="listBumpMorn"/>
        </div>
        <div class="largescreen-li" style="margin-top: 24px">
          <div class="largescreen-head">颠簸占比排行</div>
          <ranking/>
        </div>
        <div class="checbox-modal">
          <el-checkbox v-model="checkedLvl1" @change="refreshGeoJson">轻度</el-checkbox>
          <el-checkbox v-model="checkedLvl2" @change="refreshGeoJson">轻中</el-checkbox>
          <el-checkbox v-model="checkedLvl3" @change="refreshGeoJson">中度</el-checkbox>
          <el-checkbox v-model="checkedLvl4" @change="refreshGeoJson">重度</el-checkbox>
        </div>
      </div>
      <div class="map">
        <div ref="chartContainer" class="chart-container"></div>
        <!--上报-->
        <div class="report-box">
          <div class="report-li" v-for="(item, index) in errorRecordList">
            <div class="report-top">
              <div class="report-left">
                <img src="@/assets/images/larg/bg.png"/>
                <div class="report-text">
                  <div class="report-h">飞行员 <span>{{ item.createUserNickname }}</span></div>
                  <div class="report-p">刚刚 发起了飞行中故障上报</div>
                </div>
              </div>
              <div class="report-right" @click="goCheckError">
                进入查看<img src="@/assets/images/larg/arrow-right.png"/>
              </div>
            </div>
            <div class="report-bottom">
              <div class="report-bottom-li">
                <div class="report-laber">{{ item.planeType }}</div>
                <div class="report-laber">飞机类别</div>
              </div>
              <div class="report-bottom-li">
                <div class="report-laber">{{ item.flightNo }}</div>
                <div class="report-laber">航班号</div>
              </div>
              <div class="report-bottom-li">
                <div class="report-laber">{{ item.planeId }}/{{ item.msn }}</div>
                <div class="report-laber">注册号/MSN编号</div>
              </div>
            </div>
          </div>
        </div>
        <!--当前高度-->
        <div class="recorder-li">
          <div class="recorder-laber">
            <span>当前高度</span>
            <el-select popper-class="active" v-model="flightAltitude" placeholder="请选择" @change="refreshGeoJson">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="largescreen-right">
        <div class="largescreen-li">
          <div class="largescreen-head">即将起飞航班</div>
          <flight/>
        </div>
        <div class="largescreen-li" style="margin-top: 24px">
          <div class="largescreen-head">单兵执法记录仪</div>
          <recorder/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import flight from "@/views/largescreen/components/flight";
import recorder from "@/views/largescreen/components/recorder";
import echarts2 from "@/views/largescreen/components/echarts2";
import echarts3 from "@/views/largescreen/components/echarts3";
import ranking from "@/views/largescreen/components/ranking";
import {getGeoData} from "@/api/app";

const flOptions = ['FL050', 'FL060', 'FL070', 'FL080', 'FL090', 'FL100', 'FL110', 'FL120', 'FL130', 'FL140', 'FL150', 'FL160', 'FL170', 'FL180', 'FL190', 'FL200', 'FL210', 'FL220', 'FL230', 'FL240', 'FL250', 'FL260', 'FL270', 'FL280', 'FL290', 'FL300', 'FL310', 'FL320', 'FL330', 'FL340', 'FL350', 'FL360', 'FL370', 'FL380', 'FL390', 'FL400', 'FL410', 'FL420', 'FL430', 'FL440', 'FL450'].map(val => ({
  label: val,
  value: val
}))
export default {
  name: "largescreen",
  components: {flight, recorder, echarts2, echarts3, ranking},
  data() {
    return {
      flightAltitude: 'FL050',
      waiting_flight_list: [], //即将起飞的航班列表
      listQuery: {page: 1, list_rows: 10, total: 0},
      listBumpMorn: [],//早出港航班颠簸时长统计
      errorRecordList: [],//飞行中故障上报记录
      chart: null,
      checkedLvl1: true,
      checkedLvl2: true,
      checkedLvl3: true,
      checkedLvl4: true
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize)
    //3D地球初始化
    this.renderGeoJson()
    // this.getBaseTexture();

    // this.$nextTick(() => {
    //   this.getBaseTexture()
    // })
    //获取早出港航班颠簸时长
    // this.listOfDaysMor();
    //获取近几日颠簸数据统计
    // this.querybumpListOfDays()
    //获取飞行中故障上报记录
    //this.getPlaneRiskRecord()
  },
  computed: {
    options() {
      return flOptions
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    this.chart = null;
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    //进入主系统
    goSystem() {
      this.$router.push("/index");
    },
    //进入查看故障
    goCheckError() {
      this.$router.push("/eventinitiation");
    },
    onResize() {
      if (this.$refs.chart2) {
        this.$refs.chart2.size()
      }
      if (this.$refs.chart3) {
        this.$refs.chart3.size()
      }
    },
    renderGeoJson() {
      // 如果已经有一个图表实例，先销毁它
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      const geoJsonCountries = require("@/assets/countries.geo.json")
      // 注册地图数据
      echarts.registerMap('countries', {geoJSON: geoJsonCountries});
      // const geoJson = require("@/assets/geo.json")
      // echarts.registerMap('feature0', {geoJSON: geoJson})

      const chart = echarts.init(this.$refs.chartContainer)
      window.onresize = chart.resize
      this.chart = chart
      this.refreshGeoJson()
    },
    async refreshGeoJson() {
      const geoArrs = [
        {
          type: 'map',
          map: 'countries',
          left: 0, top: 0, right: 0, bottom: 0,
          // boundingCoords: [
          //   [-180, 90],
          //   [180, -90],
          // ],
          roam: false,
          itemStyle: {normal: {areaColor: "#0B232E", borderColor: "#2289AB",}, emphasis: {areaColor: "#1E6180",},},
          emphasis: {
            disabled: true
          }
          // label: {normal: {fontSize: 16, show: true, textStyle: {color: "#269DC6",},}, emphasis: {disabled: true},},
        }
      ]
      const lvlIds = []
      if (this.checkedLvl1) {
        lvlIds.push(0, 1)
      }
      if (this.checkedLvl2) {
        lvlIds.push(2)
      }
      if (this.checkedLvl3) {
        lvlIds.push(3)
      }
      if (this.checkedLvl4) {
        lvlIds.push(4, 5)
      }
      const {features} = await getGeoData(this.flightAltitude)
      for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (!lvlIds.includes(feature.id)){
          continue
        }
        const name = `feature${i}`
        if (!feature['properties']) {
          continue
        }
        feature['properties']['name'] = name
        echarts.registerMap(`feature${i}`, {
              geoJSON: {
                'type': 'FeatureCollection',
                'features': [feature]
              }
            }
        )
        geoArrs.push({
          type: 'map',
          map: name,
          // show: true,
          // zoom: 0.5,
          // min: 1,
          // max: 10,
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          roam: false,
          label: {
            show: false
          },
          regions: [
            {
              name,
              emphasis: {
                disabled: true // 关闭高亮状态
              },
              itemStyle: {
                color: feature['properties']['fill'],
                // areaColor:'#FF0000',
                // borderColor: '#FF0000',
              }
            }
          ]
        })
      }
      const baseTexture = echarts.init(
          document.createElement('canvas'),
          null,
          {width: 4096, height: 2048,}
      )
      baseTexture.setOption({
        backgroundColor: "#001420",
        geo: geoArrs
      });
      this.chart.setOption({
        tooltip: {
          show: true,
          borderColor: "rgba(255,255,255,.3)",
          backgroundColor: "rgba(13,5,30,.6)",
          borderWidth: 1,
          padding: 5,
          confine: true,
          textStyle: {
            color: "#fff",
          },
        },
        globe: {
          baseTexture: baseTexture,
          shading: "lambert",
          globeRadius: 130,
          light: {
            main: {
              color: "#fff",
              intensity: 0.8,
              alpha: 40,
              beta: -30,
            },
            ambient: {
              color: "#fff",
              intensity: 1,
            },
          },
          viewControl: {
            alpha: 35,
            beta: 160,
            autoRotate: true,
            autoRotateAfterStill: 8,
            distance: 250,
          },
        }
      })
    },
    /*******************飞行中故障上报记录*******************/
    async getPlaneRiskRecord() {
      // // this.isScroll = false
      // const query = {number: 1, limit: 10,}
      // const res = await planeRiskRecord(query)
      // console.log(res, '故障记录')
      // if (res.code === 'A00000' && res.data.length) {
      //   this.errorRecordList = [...this.errorRecordList, ...res.data]
      //
      //   // this.isScroll = true
      //   if (res.data.length < 10) {
      //     // this.isScroll = false
      //     //  this.$message.info('已全部加载完')
      //   }
      // } else {
      //
      //   // this.isScroll = false
      // }
    },
  },
};
</script>

<style lang="less">
.el-select-dropdown.active {
  background: #121F2A;
  border: 1px solid #324467;

  .el-select-dropdown__item {
    color: #fff;
  }

  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background: #409EFF;
  }

  .popper__arrow {
    border-bottom-color: #324467;
  }

  .popper__arrow::after {
    border-bottom-color: #121F2A;
  }
}
</style>
<style lang="less" scoped>
/deep/ .recorder-laber .el-select .el-input .el-select__caret {
  line-height: 25px;
}

/deep/ .recorder-laber .el-input__inner {
  height: 25px;
  width: 110px;
  border-radius: 0;
  background: none;
  font-size: 12px;
}

.height-box {
  height: 295px !important;
}

.report-box {
  position: absolute;
  right: 480px;
  top: 0;

  .report-li {
    background: #293752;
    margin-bottom: 16px;
    padding: 0 12px;
    padding-bottom: 12px;
    width: 400px;

    .report-top {
      display: flex;
      align-items: center;
      padding: 12px 0;
      justify-content: space-between;

      .report-left {
        display: flex;
        align-items: center;

        img {
          border-radius: 36px;
          border: 1px solid #fff;
          overflow: hidden;
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }

        .report-text {
          text-align: left;

          .report-h {
            color: rgba(255, 255, 255, 0.85);
            font-size: 14px;
          }

          .report-p {
            color: rgba(255, 255, 255, 0.65);
            font-size: 12px;
            margin-top: 4px;
          }
        }
      }

      .report-right {
        color: rgba(255, 255, 255, 0.85);
        font-size: 12px;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          margin-left: 4px;
          width: 14px;
        }
      }
    }

    .report-bottom {
      background: #1c2a44;
      padding: 12px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 0;

      .report-bottom-li:last-child {
        border: none;
      }

      .report-bottom-li:first-child {
        padding-left: 0;
      }

      .report-bottom-li {
        width: 33.3%;
        border-right: 1px solid #393f52;
        text-align: left;
        padding-left: 20px;

        .report-laber {
          color: rgba(255, 255, 255, 0.85);
          font-size: 12px;
        }

        .report-laber:first-child {
          margin-bottom: 4px;
        }
      }
    }
  }
}

.chart-container {
  width: 100%;
  height: calc(1080px - 74px);
}

.largescreen-right {
  position: absolute;
  right: 0;
  top: 20px;
}

.largescreen-left {
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 9;
}

.map {
  position: relative;
}

.recorder-li {
  right: 480px;
  top: 50px;
  border: 1px solid #324467;
  padding: 8px;
  margin-right: 8px;
  cursor: pointer;
  position: absolute;

  .recorder-laber {
    display: flex;
    align-items: center;
    color: rgba(194, 217, 245, 0.65);
    font-size: 14px;

    img {
      width: 12px;
      margin-left: 4px;
    }

    p {
      width: 6px;
      background: #aaf688;
      border-radius: 50%;
      height: 6px;
      margin: 0;
      margin-left: 4px;
    }

    span {
      background: #293752;
      color: #c2d9f5;
      font-size: 12px;
      height: 12px;
      padding: 4px 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
    }
  }
}

.largescreen-box {
  position: relative;
  width: 100%;
}

.largescreen-li {
  background: url("~@/assets/images/larg/bg2.png") no-repeat rgba(0, 0, 0, 0.1) top;
  background-size: 100%;
  width: 450px;

  .largescreen-head {
    color: #c2d9f5;
    font-size: 20px;
    text-align: left;
  }
}

.largescreen-page {
  height: 100vh;
  width: 100%;
  /*background: url("~@/assets/images/larg/bg.png");*/
  /*background-size: 100% 100%;*/
  background: #162634;
  padding: 16px 24px;
  box-sizing: border-box;
  color: #fff;

  .largescreen-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .top-left {
      display: flex;
      align-items: center;
    }

    img {
      width: 16px;
      height: 16px;
      margin-right: 12px;
    }

    span {
      width: 72px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: rgba(194, 217, 245, 1);
      cursor: pointer;
      background: #293752;
    }

    p {
      margin: 0;
      font-size: 32px;
      font-weight: bold;
      margin-right: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/largescreen/largescreen.vue